import { propertyType } from 'shared/constants.json';

const getUid = (current, key) => {
  if (typeof current[key] === 'undefined') {
    return [];
  }

  return current[key].map((u) => ({ uid: u.uid }));
};

const getSelectedOptions = (value) => {
  if (value.property.type === propertyType.singleSelect) {
    if (typeof value.selectedOptions === 'undefined' || value.selectedOptions.length === 0) {
      return [];
    }
    return [{ uid: value.selectedOptions[0].uid }];
  }

  return getUid(value, 'selectedOptions');
};

const getScope = (acc, c) => {
  if (c.op === 'not') {
    return acc;
  }

  if (c.scope === null || typeof c.scope === 'undefined') {
    c.children.forEach((child) => getScope(acc, child));
    return acc;
  }

  return acc.push(c.scope);
};

export const getPropertyValuesFromFilter = (filter, defaultProperties, propertyValuesKey = 'properties') => {
  if (filter === null) {
    return { [propertyValuesKey]: defaultProperties };
  }

  const scopes = filter.children.reduce((acc, current) => getScope(acc, current), []);

  const reducer = (acc, current) => {
    if (current.isEmpty === true) {
      return acc;
    }

    if (typeof current.directProperty !== 'undefined') {
      if (Array.isArray(current.relations) && current.relations.length > 0) {
        acc[current.directProperty.edgeName] = current.relations;
        return acc;
      }

      if (current.selectedOptions.length > 0) {
        acc[current.directProperty.edgeName] = current.selectedOptions[0].value;
        return acc;
      }

      return acc;
    }

    if ([propertyType.number, propertyType.date].includes(current.property.type)) {
      return acc;
    }

    if (acc[propertyValuesKey].map((p) => p.property.uid).includes(current.property.uid)) {
      let index = -1;
      acc[propertyValuesKey].forEach((p, i) => {
        if (p.property.uid === current.property.uid) {
          index = i;
        }
      });

      acc[propertyValuesKey][index] = {
        property: { uid: current.property.uid },
        selectedOptions: getSelectedOptions(current),
        spaces: getUid(current, 'spaces'),
        users: getUid(current, 'users'),
      };
      return acc;
    }

    acc[propertyValuesKey].push({
      property: { uid: current.property.uid },
      selectedOptions: getSelectedOptions(current),
      spaces: getUid(current, 'spaces'),
      users: getUid(current, 'users'),
    });
    return acc;
  };

  return scopes.reduce(reducer, { [propertyValuesKey]: defaultProperties });
};

export const isEmpty = (p, value) => {
  switch (p.type) {
    case propertyType.date:
      return value.timestamp === null;
    case propertyType.space:
      return value.spaces.length === 0;
    case propertyType.status:
    case propertyType.options:
    case propertyType.singleSelect:
      return value.selectedOptions.length === 0;
    case propertyType.number:
      return value.number === null;
    case propertyType.text:
    case propertyType.url:
      return value.text === null || value.text === '';
    case propertyType.user:
      return value.users.length === 0;
    case propertyType.lookup:
      switch (p.lookupProperty.type) {
        case propertyType.user:
          return value.users.length === 0;
        case propertyType.space:
          return value.spaces.length === 0;
        case propertyType.options:
        case propertyType.singleSelect:
          return value.selectedOptions.length === 0;
        default:
          return true;
      }
    default:
      return true;
  }
};
